module.exports = __webpack_public_path__ + "assets/bar-w.a6b017ca.png";